import { render, staticRenderFns } from "./StreamInfo.vue?vue&type=template&id=37574d06&scoped=true&"
import script from "./StreamInfo.vue?vue&type=script&lang=js&"
export * from "./StreamInfo.vue?vue&type=script&lang=js&"
import style0 from "./StreamInfo.vue?vue&type=style&index=0&id=37574d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37574d06",
  null
  
)

export default component.exports